import { Component, OnInit, HostListener } from '@angular/core';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { Approval } from '../../models/Approval.model';
import { ApprovalService } from '../../services/approval.service';
import { ConsultantService } from '../../services/consultant.service';
import { Consultant } from '../../models/Consultant.model';
import { ApprovalsSearchFactory } from '../../shared/factories/approvals/ApprovalsSearch.factory';
import { DropDownList } from '../../models/DropDownList.model';
import { CompaniesService } from '../../services/companies.service';
import { CompanyService } from '../../services/billing-letter/company.service';
import { Company } from '../../models/Company.model';
import { GroupDivision } from '../../shared/enums/GroupDivision';
import { ContractType } from '../../shared/enums/ContractType';
import { ConsultantSearch } from '../../models/ConsultantSearch.model';
import { LocalStorage } from "../../shared/wrappers/LocalStorage";
import { Json2csvService } from "../../services/json2csv.service";
import { ProjectFinancialService } from "../../services/projectFinancial.service";
import { CompanySearch } from '../../models/CompanySearch.model';
import  *  as _ from "lodash";
import { OwnerService } from '../../services/billing-letter/owner.service';
import { AwsService } from '../../services/aws.service';
import { ToastsManager } from "ng2-toastr";
import { IndustriesService } from '../../services/industries.service';
import { ExcellenceCentersService } from '../../services/excellenceCenters.service';
import { VerifyCreatedDate } from "../../shared/helpers/verify-created-date";
import { GUARDS } from '../../shared/auth/Roles';
import * as moment from "moment";

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.scss']
})
export class ApprovalsComponent implements OnInit {

  dropDownListConsultants: DropDownList[] = new Array<DropDownList>();
  dropDownListYears: DropDownList[] = new Array<DropDownList>();
  dropDownListMonths: DropDownList[] = new Array<DropDownList>();
  dropDownListProjects: DropDownList[] = new Array<DropDownList>();
  dropDownListCompanies: DropDownList[] = new Array<DropDownList>();
  dropDownListStatus: DropDownList[] = new Array<DropDownList>();
  dropDownListStatusInvoice: DropDownList[] = new Array<DropDownList>();
  dropDownListResponsible: DropDownList[] = new Array<DropDownList>();
  dropDownListContract: DropDownList[] = new Array<DropDownList>();
  dropDownListCompanyGroups: DropDownList[] = new Array<DropDownList>();
  dropDownListLenders: DropDownList[] = new Array<DropDownList>();
  dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
  dropDownListSupportCenters: DropDownList[] = new Array<DropDownList>();
  dropDownListIndustries: DropDownList[] = new Array<DropDownList>();
  dropDownListCompanyNames: DropDownList[] = new Array<DropDownList>();

  selectedConsultantsItems: DropDownList[] = new Array<DropDownList>();
  selectedYearsItems: DropDownList[] = new Array<DropDownList>();
  selectedMonthsItems: DropDownList[] = new Array<DropDownList>();
  selectedProjectsItems: DropDownList[] = new Array<DropDownList>();
  selectedCompaniesItems: DropDownList[] = new Array<DropDownList>();
  selectedStatusItems: DropDownList[] = new Array<DropDownList>();
  selectedStatusInvoiceItems: DropDownList[] = new Array<DropDownList>();
  selectedApprovalConsultantItems: DropDownList[] = new Array<DropDownList>();
  selectedResponsibleItems: DropDownList[] = new Array<DropDownList>();
  selectedContractItems: DropDownList[] = new Array<DropDownList>();
  selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
  selectedLendersItems: DropDownList[] = new Array<DropDownList>();
  selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();
  selectedSupportCentersItems: DropDownList[] = new Array<DropDownList>();
  selectedCompanyNamesItems: DropDownList[] = new Array<DropDownList>();
  selectedIndustriesItems: DropDownList[] = new Array<DropDownList>();

  dropDownConsultantsSettings = {};
  dropDownYearsSettings = {};
  dropDownMonthsSettings = {};
  dropDownProjectsSettings = {};
  dropDownCompaniesSettings = {};
  dropDownStatusSettings = {};
  dropDownStatusInvoiceSettings = {};
  dropDownResponsibleSettings = {};
  dropDownContractSettings = {};
  dropDownCompanyGroupsSettings = {};
  dropDownLendersSettings = {};
  dropDownExcellenceCentersSettings = {};
  dropDownSupportCentersSettings = {};
  dropDownCompanyNamesSettings = {};
  dropDownIndustriesSettings = {};

  totalValue: number;
  approvalSearchFactory = new ApprovalsSearchFactory();
  commonHelper: CommonHelper = new CommonHelper();
  multiApprovals: Approval[] = new Array<Approval>();
  approvals: Approval[] = new Array<Approval>();
  itemsPerPage: number[] = [5, 10, 50, 100];
  totalItems: number = 0;
  currentPage: number = 1;
  consultants: Consultant[] = new Array<Consultant>();
  companies: Company[] = new Array<Company>();
  industries: any[] = new Array<any>();
  approvalsSearch;
  projects: Array<any> = [];
  companyGroups: Array<any> = [];
  months: Array<any> = [];
  loading: boolean;
  approvalsExport: Approval[] = new Array<Approval>();
  companySearch:CompanySearch = new CompanySearch();
  companiesFinancial;
  yearList;
  byProject:boolean = false;
  canExport:boolean =true;
  approvalType:number;
  discount;
  mensalHours;
  totalProjectHours = 0;
  days;
  responsibles;
  fileList = new Array();
  downloadUrlInvoiceAttach: string = '';
  excellenceCenters: any[] = new Array<any>();
  supportCenters: any[] = new Array<any>();
  allCenters: any[] = new Array<any>();
  companyNames: any[] = []
  currentUser
  showValue: boolean = true;

  constructor(
    private approvalService: ApprovalService,
    private consultantService: ConsultantService,
    private companiesService: CompaniesService,
    private companyGroupService: CompanyService,
    private LocalStorage: LocalStorage,
    private json2csvService: Json2csvService,
    private projectFinancialService: ProjectFinancialService,
    private responsibleService: OwnerService,
    public toastr:ToastsManager,
    private awsService: AwsService,
    private excellenceCentersService: ExcellenceCentersService,
    private industriesService: IndustriesService
) { }

  async ngOnInit() {
    this.currentUser = this.LocalStorage.retrieve('user')
    this.loading = true;
    this.approvalService.multiApprovals = [];
    this.yearList = this.commonHelper.listLastYears()
        .map(year => ({ _id: String(year), name: String(year) }));
    this.months = this.commonHelper.multiSelectMonths();
    this.responsibles = await this.responsibleService.getAll();
    var response = await this.projectFinancialService.getProjectsAndCustomers();
    this.approvalsSearch = this.approvalSearchFactory.newSearch();
    if (this.LocalStorage.retrieve("approval"))
        this.setFilters();
    let consultantSearch = new ConsultantSearch();
    consultantSearch.onlyActives = false;
    consultantSearch.limit = 9999999;
    this.companySearch.limit = 99999;
    this.companySearch.onlyCustomer = true;
    this.companiesFinancial = await this.companiesService.searchCompanies(this.companySearch,'_id,name,cnpj');
    consultantSearch.fields = ["_id", "name","active"];
    this.consultants = await this.consultantService.searchConsultants(consultantSearch);
    this.companies = response.customers;
    this.projects = response.projects;
    this.companyGroups = await this.companyGroupService.getAllCompanyGroups();
    this.addCustomer(this.companiesFinancial,this.companies);
    this.companies = _.sortBy(this.companies,"name");

    this.allCenters = await this.excellenceCentersService.getAll();
    this.excellenceCenters = this.allCenters.filter(center => center.type == 1 );
    this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

    this.supportCenters = this.allCenters.filter(center => center.type == 2 );
    this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

    this.industries = await this.industriesService.getAll();
    this.companyNames = await this.approvalService.getCompanyNamesWithApprovals()

    this.dropDownListResponsible = this.commonHelper.getDropDownListItems(this.responsibles, "_id", "name");
    this.dropDownListConsultants = this.commonHelper.getDropDownListConsultant(this.consultants, "_id", "name",null,null,"active",null);
    this.dropDownListCompanies = this.commonHelper.getDropDownListItems(this.companies, "_id", "name");
    this.dropDownListProjects = this.commonHelper.getDropDownListItems(this.projects, "_id", "name");
    this.dropDownListStatus = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllStatusApproval(), "StatusApproval");
    this.dropDownListStatusInvoice = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getStatusInvoice(), "StatusInvoice");
    this.dropDownListYears = this.commonHelper.getDropDownListItems(this.yearList, "_id", "name");
    this.dropDownListMonths = this.commonHelper.getDropDownListItems(this.months, "_id", "name");
    this.dropDownListContract = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllContractType(), "Contract");

    if (this.currentUser.permission === GUARDS.DP) {
      this.dropDownListContract = this.commonHelper.getDropDownListItemsEnum([ContractType.CLT, ContractType.Intern], "Contract");
    }

    this.dropDownListCompanyGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
    this.dropDownListLenders = this.commonHelper.getDropDownListConsultant(this.consultants, "_id", "name",null,null,"active",null);
    this.dropDownListIndustries = this.commonHelper.getDropDownListItems(this.industries, "_id", "name");
    this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(this.excellenceCenters, "_id", "name");

    if (this.currentUser.permission === GUARDS.BUSINESSPARTNER) {
      this.showValue = false;
      const userExcellenceCenterIds = this.currentUser.excellenceCenters.map(({_id}) => _id);
      const userExcellenceCenters = this.excellenceCenters.filter(({_id}) => userExcellenceCenterIds.includes(_id))
      this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(userExcellenceCenters, "_id", "name");
    }

    this.dropDownListSupportCenters = this.commonHelper.getDropDownListItems(this.supportCenters, "_id", "name");
    this.dropDownListCompanyNames = this.commonHelper.getDropDownListItems(this.companyNames, "_id", "name")
    this.dropDownResponsibleSettings = this.commonHelper.getDropDownSettings(false, 'Gestores', false, 'Marcar todos os responsaveis', 'Desmarcar todos os responsaveis',true,null, '');
    this.dropDownConsultantsSettings = this.commonHelper.getDropDownSettings(false, 'Consultores', false, 'Marcar todos os consultores', 'Desmarcar todos os consultores', true,'active','');
    this.dropDownCompaniesSettings = this.commonHelper.getDropDownSettings(false, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true,null, '');
    this.dropDownProjectsSettings = this.commonHelper.getDropDownSettings(false, 'Projetos', false, 'Marcar todos os projetos', 'Desmarcar todos os projetos', true,null, '');
    this.dropDownStatusSettings = this.commonHelper.getDropDownSettings(false, 'Status', false, 'Marcar todos os status', 'Desmarcar todos os status', true,null, '');
    this.dropDownStatusInvoiceSettings = this.commonHelper.getDropDownSettings(false, 'Status da Nota', false, 'Marcar todos os status da nota', 'Desmarcar todos os status da nota', true,null, '');
    this.dropDownYearsSettings = this.commonHelper.getDropDownSettings(false, 'Anos', false, '', '', false,null, '');
    this.dropDownMonthsSettings = this.commonHelper.getDropDownSettings(false, 'Meses', true, 'Marcar todos os meses', 'Desmarcar todos os meses', true,null, '');
    this.dropDownContractSettings = this.commonHelper.getDropDownSettings(false, 'Contrato', false, 'Marcar todos os modelos de contrato', 'Desmarcar todos os modelos de contrato', true,null, '');
    this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(false, 'Grupo de empresa', false, 'Marcar todos os grupos', 'Desmarcar todos os grupos', true,null, '');
    this.dropDownLendersSettings = this.commonHelper.getDropDownSettings(false, 'Emprestador de NF', false, 'Marcar todos os emprestadores', 'Desmarcar todos os emprestadores', true,'active','');

    this.dropDownIndustriesSettings = this.commonHelper.getDropDownSettings(false, 'Setor', true, 'Marcar todos os setores', 'Desmarcar todos os setores', true, null, '');
    this.dropDownExcellenceCentersSettings = this.commonHelper.getDropDownSettings(false, 'Centro de Excelência', true, 'Marcar todos os centros', 'Desmarcar todos os centros', true, null, '');
    this.dropDownSupportCentersSettings = this.commonHelper.getDropDownSettings(false, 'Área de Suporte', true, 'Marcar todas as Áreas', 'Desmarcar todos os centros', true, null, '');
    this.dropDownCompanyNamesSettings = this.commonHelper.getDropDownSettings(false, 'Razão Social', true, 'Marcar todas', 'Desmarcar todas', true, null, '');

    await this.search(1);
  }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.search(1);
        }

    }

  async search(page?: number, toexport?: boolean) {

    let limit;
    this.loading = true;
    this.byProject = this.approvalsSearch.byProject;
    this.currentPage = page ? page : 1;
    this.approvalsSearch.skip = (this.currentPage - 1) * this.approvalsSearch.limit;
    if (toexport) {
      limit = this.approvalsSearch.limit;
      this.approvalsSearch.skip = 0;
      delete this.approvalsSearch.limit;
    }
    this.approvalsSearch.consultants = [];
    this.approvalsSearch.projects = [];
    this.approvalsSearch.divisions = [];
    this.approvalsSearch.subDivisions = [];
    this.approvalsSearch.groups = [];
    this.approvalsSearch.statusApprovals = [];
    this.approvalsSearch.statusInvoices = [];
    this.approvalsSearch.companies = [];
    this.approvalsSearch.companyGroups = [];
    this.approvalsSearch.responsibles = [];
    this.approvalsSearch.years = [];
    this.approvalsSearch.months = [];
    this.approvalsSearch.contracts = [];
    this.approvalsSearch.lenders = [];
    this.approvalsSearch.excellenceCenters = [];
    this.approvalsSearch.supportCenters = [];
    this.approvalsSearch.industries = [];
    this.approvalsSearch.companyNames = [];

    for (let c of this.selectedConsultantsItems)
        this.approvalsSearch.consultants.push(c.id);

    for (let s of this.selectedStatusItems)
        this.approvalsSearch.statusApprovals.push(parseInt(s.id));

    for (let si of this.selectedStatusInvoiceItems)
        this.approvalsSearch.statusInvoices.push(parseInt(si.id));

    for (let contract of this.selectedContractItems)
        this.approvalsSearch.contracts.push(parseInt(contract.id));

    for (let p of this.selectedProjectsItems)
        this.approvalsSearch.projects.push(p.id);

    for (let comp of this.selectedCompaniesItems)
        this.approvalsSearch.companies.push(comp.id);

    for (let cg of this.selectedCompanyGroupsItems)
        this.approvalsSearch.companyGroups.push(cg.id);

    for (let resp of this.selectedResponsibleItems)
        this.approvalsSearch.responsibles.push(resp.id);

    for (let l of this.selectedLendersItems)
        this.approvalsSearch.lenders.push(l.id);

    for (let i of this.selectedIndustriesItems)
        this.approvalsSearch.industries.push(i.id);

    for (let ec of this.selectedExcellenceCentersItems)
        this.approvalsSearch.excellenceCenters.push(ec.id);

    for (let ec of this.selectedSupportCentersItems)
        this.approvalsSearch.supportCenters.push(ec.id);

    for (let companyName of this.selectedCompanyNamesItems)
        this.approvalsSearch.companyNames.push(companyName.itemName);

    if (this.currentUser.permission === GUARDS.DP) {
        this.approvalsSearch.contracts = [ContractType.CLT, ContractType.Intern];
    }

    if (this.currentUser.permission === GUARDS.BUSINESSPARTNER && !this.approvalsSearch.excellenceCenters.length) {
        this.currentUser.excellenceCenters.forEach(({_id}) => this.approvalsSearch.excellenceCenters.push(_id));
    }

    if(this.selectedYearsItems.length > 0) {
        for (let year of this.selectedYearsItems)
            this.approvalsSearch.years.push(year.id);
    } else {
        const currentYear = this.yearList.find(y => y._id === String(new Date().getFullYear()));
        this.selectedYearsItems.push({ id: currentYear._id, itemName: currentYear.name });
        this.approvalsSearch.years.push(currentYear._id);
    }

    if(this.selectedMonthsItems.length > 0) {
        for (let month of this.selectedMonthsItems)
            this.approvalsSearch.months.push(month.id);
    } else {
        const currentMonth = this.months.find(m => m._id === String(new Date().getMonth()));
        this.selectedMonthsItems.push({ id: currentMonth._id, itemName: currentMonth.name });
        this.approvalsSearch.months.push(currentMonth._id);
    }

    if (toexport) {
      this.approvalsExport = await this.approvalService.search(this.approvalsSearch);
      this.approvalsSearch.limit = limit;
    } else {
      this.approvals = await this.approvalService.search(this.approvalsSearch);
      this.totalItems = this.approvalsSearch.totalItems;
      this.totalValue = this.approvalsSearch.totalValue;
    }
    await this.getS3Links();
    this.canExport = true;
    this.loading = false;
  }

  async searchMultipleApprovals(){
      this.loading = true;

      this.clearMultiApprovalData();

      let approvalsSearch = this.approvalSearchFactory.newSearch();
      approvalsSearch.year = this.approvalsSearch.year;
      approvalsSearch.month = parseInt(this.approvalsSearch.month);

      for (let c of this.selectedApprovalConsultantItems)
          approvalsSearch.consultants.push(c.id);
      approvalsSearch.statusApprovals.push(1);

      this.multiApprovals = await this.approvalService.search(approvalsSearch);

      this.calculateTotalValues(this.multiApprovals);

      this.selectedApprovalConsultantItems = [];

      this.loading = false;
  }

  buldContractType(approval: Approval) {
    let type = approval.consultant.contract.kind;
    let honor = approval.consultant.contract.honorarium;

    let transcriptType = this.commonHelper.transcriptContractType(type);
    let transcriptHonor = this.commonHelper.transcriptHonorariumType(honor);

    if (type === ContractType.PJ)
      return `${transcriptType} (${transcriptHonor})`;

    return `${transcriptType}`;
  }

  buildCutomersForGrid(approval: Approval) {
    let response = "";
    for (var i = 0; i < approval.projects.length; i++) {

      if (approval.projects[i].customer !== undefined && approval.projects[i].customer.name !== undefined) {
        response += approval.projects[i].customer.name;

        if (i < (approval.projects.length - 1))
          response += ",";
      }
    }

    return response;
  }

  buildFinancialCutomersForGrid(approval: Approval) {
    let response = "";
    for (var i = 0; i < approval.projects.length; i++) {

      if (approval.projects[i].customer !== undefined && approval.projects[i].customer.financialName !== undefined) {
        response += approval.projects[i].customer.financialName;

        if (i < (approval.projects.length - 1))
          response += ",";
      }
    }

    return response;
  }

  buildFinancialCompanyGroupsForGrid(approval: Approval) {
    let companyGroups = [];
    approval.projects.forEach(project => {
        if(project.projectDetails &&
            project.projectDetails.length > 0 &&
            project.projectDetails[0].companyGroup){
              companyGroups.push(project.projectDetails[0].companyGroup.name);
        }
    });
    return companyGroups.join(',');
  }

  buildIndustriesForGrid(approval: Approval) {
    let industries = [];
    approval.projects.forEach(project => {
      if(project.customer && project.customer.details && project.customer.details.industry)
          industries.push(project.customer.details.industry.name);
    });
    return industries.join(', ');
  }

  buildExcellenceCenterForGrid(approval: Approval) {
    let excellenceCenters = [];
    approval.projects.forEach(project => {
      if(project.excellenceCenter)
        excellenceCenters.push(project.excellenceCenter.name);
    });
    return excellenceCenters.filter((item, pos) => excellenceCenters.indexOf(item) == pos).join(', ');
  }

  onChange() {
    this.LocalStorage.persist("approval", {
        approvalsSearch: this.approvalsSearch,
        selectedConsultantsItems:this.selectedConsultantsItems,
        selectedCompaniesItems: this.selectedCompaniesItems,
        selectedStatusItems:this.selectedStatusItems,
        selectedStatusInvoiceItems:this.selectedStatusInvoiceItems,
        selectedContractItems:this.selectedContractItems,
        selectedProjectsItems: this.selectedProjectsItems,
        selectedYearsItems: this.selectedYearsItems,
        selectedMonthsItems: this.selectedMonthsItems,
        selectedResponsibleItems: this.selectedResponsibleItems,
        selectedCompanyGroupsItems: this.selectedCompanyGroupsItems,
        selectedLendersItems: this.selectedLendersItems,
        selectedIndustriesItems: this.selectedIndustriesItems,
        selectedExcellenceCentersItems: this.selectedExcellenceCentersItems,
        selectedSupportCentersItems: this.selectedSupportCentersItems,
        selectedCompanyNamesItems: this.selectedCompanyNamesItems
    });
  }

  setFilters(){
      let storage = this.LocalStorage.retrieve("approval");
      if(storage.approvalsSearch)
        this.approvalsSearch = storage.approvalsSearch;
      this.selectedConsultantsItems = storage.selectedConsultantsItems || [];
      this.selectedCompaniesItems = storage.selectedCompaniesItems || [];
      this.selectedStatusItems = storage.selectedStatusItems || [];
      this.selectedStatusInvoiceItems = storage.selectedStatusInvoiceItems || [];
      this.selectedContractItems = storage.selectedContractItems || [];
      this.selectedProjectsItems = storage.selectedProjectsItems || [];
      this.selectedYearsItems = storage.selectedYearsItems || [];
      this.selectedMonthsItems = storage.selectedMonthsItems || [];
      this.selectedResponsibleItems = storage.selectedResponsibleItems || [];
      this.selectedCompanyGroupsItems = storage.selectedCompanyGroupsItems || [];
      this.selectedLendersItems = storage.selectedLendersItems || [];
      this.selectedIndustriesItems = storage.selectedIndustriesItems || [];
      this.selectedExcellenceCentersItems = storage.selectedExcellenceCentersItems || [];
      this.selectedSupportCentersItems = storage.selectedSupportCentersItems || [];
      this.selectedCompanyNamesItems = storage.selectedCompanyNamesItems || [];
  }

  clearMultiApprovalData(){
      this.multiApprovals = [];
  }

  async export() {
    await this.search(1, true);
    this.json2csvService.export(
      this.approvalsExport.map(approval => {
        let existsSupportCenter  = approval.consultant.supportCenter && approval.consultant.supportCenter.name
        let supportCenterName = existsSupportCenter ? approval.consultant.supportCenter.name : "OTHERS"
        let excellenceCenterName = approval.consultant.excellenceCenter && approval.consultant.excellenceCenter.name ? approval.consultant.excellenceCenter.name : "-";
        if(!this.approvalsSearch.byProject)
          return {
          Consultor: approval.consultant.name ? approval.consultant.name : "-",
          "Código PN": approval.consultant.details ? approval.consultant.details.sapCardCode : "-",
          BP: approval.consultant.details ? approval.consultant.details.bp.name : "-",
          Contrato: this.buldContractType(approval) ? this.buldContractType(approval) : "-",
          "Razão Social": approval.consultant.contract.companyName || "-",
          Cliente_Hashtrack: (!this.byProject && approval.projects && (this.buildCutomersForGrid(approval))? this.buildCutomersForGrid(approval) : "-"),
          "Grupo de empresa": (!this.byProject && approval.projects && (this.buildFinancialCompanyGroupsForGrid(approval))?this.buildFinancialCompanyGroupsForGrid(approval):'-'),
          Cliente: (!this.byProject && approval.projects && (this.buildFinancialCutomersForGrid(approval))?this.buildFinancialCutomersForGrid(approval):'-'),
          Projeto: (!this.byProject && approval.projects)?this.projectsToString(approval.projects):"-",
          "Setor": (!this.byProject && approval.projects)?this.buildIndustriesForGrid(approval):"-",
          "Centro de Excelência": excellenceCenterName,
          "Área de Suporte": this.verifyApprovalDate(approval) ? '-' : supportCenterName,
          Status: approval.status ? this.commonHelper.transcriptStatusApproval(approval.status) : "-",
          Gestor: approval.consultant.responsible.name ? approval.consultant.responsible.name : "-",
          Competencia: approval.date ? this.commonHelper.formatMonth(new Date(approval.date).getMonth()) : "-",
          Ano: approval.date ? new Date(approval.date).getFullYear() : "-",
          Horas_Realizadas: approval.realizedHours ? approval.realizedHours.toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : "-",
          Horas_Aprovadas: approval.approvedHours ? approval.approvedHours.toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : "-",
          "Emprestador da NF": approval.borrowedInvoice && approval.borrowedInvoice.cnpj ? `${approval.borrowedInvoice.name} - ${approval.borrowedInvoice.cnpj} - ${approval.borrowedInvoice.sapCardCode}` : "-",
          "Status da NF": approval.approvalInvoice && approval.approvalInvoice.status ? this.commonHelper.transcriptStatusInvoice(approval.approvalInvoice.status):"Não enviada",
          "Data de envio NF": approval.approvalInvoice && approval.approvalInvoice.dateInvoice ? moment(approval.approvalInvoice.dateInvoice).format('DD/MM/YYYY, h:mm:ss') : "",
          Valor: approval.totalValue ? approval.totalValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : "-",
          Valor_contabil: approval.accountingTotalValue ? approval.accountingTotalValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : "-",
          Elegível_Desconto_Contrato: approval.elegibleForDiscount? (approval.elegibleForDiscount.byContract ? "Sim" : "Não") : "Não computado",
          Elegível_Desconto_Capacidade: approval.elegibleForDiscount? (approval.elegibleForDiscount.byCapacity ? "Sim" : "Não") : "Não computado",
          Tipo_aprovação: approval.approvalType ? this.transcriptApprovalType(approval.approvalType) : '-',
          Custo_Despesa: approval.projects ? this.transcriptApprovalExpense(approval.projects):'-',
          Descontado:approval.discounted ? "sim" : "Não",
          Horas_Desconto:approval.discountHours ? approval.discountHours.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
          Valor_Desconto:approval.discountValue ? approval.discountValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
          Extras: approval.extras ? "Sim" : "Não",
          Horas_Extras: approval.extrasHours ? approval.extrasHours.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
          Valor_Extras: approval.extrasValue ? approval.extrasValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
          Criado_Manualmente: (approval.manualApproval && approval.manualApproval.created) ? "Sim" : "Não",
          Total_Editado: (approval.manualApproval && approval.manualApproval.totalEdited) ? "Sim" : "Não",
          Horas_editadas: (approval.manualApproval && approval.manualApproval.hoursEdited) ? "Sim" : "Não",
        };
        else
          return {
              Consultor: approval.consultant.name ? approval.consultant.name : "-",
              "Código PN": approval.consultant.details ? approval.consultant.details.sapCardCode : "-",
              BP: approval.consultant.details ? approval.consultant.details.bp.name : "-",
              Contrato: this.buldContractType(approval) ? this.buldContractType(approval) : "-",
              "Razão Social": approval.consultant.contract.companyName || "-",
              Cliente_Hashtrack: this.byProject && approval.projects.customer.name? approval.projects.customer.name : '-',
              "Grupo de empresa": approval.projects.projectDetails && approval.projects.projectDetails.length > 0 &&
                approval.projects.projectDetails[0].companyGroup ? approval.projects.projectDetails[0].companyGroup.name : "-",
              Cliente: this.byProject && approval.projects.customer.financialName? approval.projects.customer.financialName : "-",
              Projeto: this.byProject && approval.projects.name?approval.projects.name:"-",
              "Setor": this.byProject && approval.projects.customer.details && approval.projects.customer.details.industry ?
                approval.projects.customer.details.industry.name:"-",
              "Centro de Excelência": excellenceCenterName,
              "Área de Suporte": !VerifyCreatedDate(approval) ?  '-' : supportCenterName,
              Valor_Hora: approval.consultant.contract.hourValue ? approval.consultant.contract.hourValue.toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : "-",
              Status: approval.status ? this.commonHelper.transcriptStatusApproval(approval.status) : "-",
              Gestor: approval.consultant.responsible.name ? approval.consultant.responsible.name : "-",
              Competencia: approval.date ? this.commonHelper.formatMonth(new Date(approval.date).getMonth()) : "-",
              Ano: approval.date ? new Date(approval.date).getFullYear() : "-",
              Horas_Realizadas: approval.projects.total_hours ? approval.projects.total_hours.toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : "-",
              Horas_Aprovadas: approval.projects.approvedHours ? approval.projects.approvedHours.toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : ((approval.dateApproved && approval.projects.total_hours)?approval.projects.total_hours.toLocaleString("pt-BR",{maximumSignificantDigits : 4}): "-"),
              "Emprestador da NF": approval.borrowedInvoice && approval.borrowedInvoice.cnpj ? `${approval.borrowedInvoice.name} - ${approval.borrowedInvoice.cnpj} - ${approval.borrowedInvoice.sapCardCode}` : "-",
              "Status da NF": approval.approvalInvoice && approval.approvalInvoice.status ? this.commonHelper.transcriptStatusInvoice(approval.approvalInvoice.status):"Não enviada",
              "Data de envio NF": approval.approvalInvoice && approval.approvalInvoice.dateInvoice ? moment(approval.approvalInvoice.dateInvoice).format('DD/MM/YYYY, h:mm:ss') : "",
              Valor: approval.projects.approvedValue ? approval.projects.approvedValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : (approval.dateApproved?(this.getTotalValue(approval).toLocaleString("pt-BR",{maximumSignificantDigits : 8})):"-"),
              Valor_contabil: approval.accountingTotalValue ? approval.accountingTotalValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : "-",
              Elegível_Desconto_Contrato: approval.elegibleForDiscount? (approval.elegibleForDiscount.byContract ? "Sim" : "Não") : "Não computado",
              Elegível_Desconto_Capacidade: approval.elegibleForDiscount? (approval.elegibleForDiscount.byCapacity ? "Sim" : "Não") : "Não computado",
              Tipo_aprovação: approval.approvalType ? this.transcriptApprovalType(approval.approvalType) : '-',
              Custo_Despesa: approval.projects.projectDetails && approval.projects.projectDetails.length > 0 &&
                  approval.projects.projectDetails[0].projectExpense ? "Despesa" : "Custo",
              Descontado:approval.discounted ? "sim" : "Não",
              Horas_Desconto:approval.discountHours ? approval.discountHours.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
              Valor_Desconto:approval.discountValue ? approval.discountValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
              Extras: approval.extras ? "Sim" : "Não",
              Horas_Extras: approval.extrasHours ? approval.extrasHours.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
              Valor_Extras: approval.extrasValue ? approval.extrasValue.toLocaleString("pt-BR",{maximumSignificantDigits : 8}) : 0,
              Criado_Manualmente: (approval.manualApproval && approval.manualApproval.created) ? "Sim" : "Não",
              Total_Editado: (approval.manualApproval && approval.manualApproval.totalEdited) ? "Sim" : "Não",
              Horas_editadas: (approval.manualApproval && approval.manualApproval.hoursEdited) ? "Sim" : "Não",
          };
      }),
      `relatório de aprovações - ${new Date().toLocaleDateString('pt-br')}`
    );
  }

    addCustomer(financial,companies){
      financial.map(item=>{
          if (!companies.find(fnd => fnd._id == item._id)) {
            companies.push({_id:item._id,name:item.name});
          }
      });
    }

    setCanExport(){
        this.canExport = false;
    }

    getTotalValue(approval){
        let hours = approval.projects.total_hours,
            value = approval.consultant.contract.hourValue;
        return (Math.ceil(hours * value ));
    }

    projectsToString(projects){
        let string = '';
        for(let project of projects){
            if(project.name)
                string = string.concat(`,${project.name}`);
        }
        string = string.slice(1);
        return string
    }


    calculateTotalValues(multiApprovals){
        for(let approval of multiApprovals){
            if(approval.status=1){
                approval.totalValue = 0;
                approval.realizedHours = 0;
                for(let project of approval.projects){
                    project.approvedHours = project.total_hours;
                    project.approvedValue = (project.total_hours*approval.consultant.contract.hourValue);
                    approval.realizedHours += project.total_hours;
                    approval.totalValue += (project.total_hours*approval.consultant.contract.hourValue);
                }
                if(!this.discount && approval.totalValue < approval.consultant.contract.totalValue){
                    approval.totalValue = approval.consultant.contract.totalValue;
                }else{
                  approval.totalValue = Math.round(approval.totalValue/10)*10;
                }

                approval.approvedHours = approval.realizedHours;
            }
        }
    }

    async approve(multiApprovals){
        let user = this.LocalStorage.retrieve("user"),
            approver = user.username;
        for(let approval of multiApprovals){
            approval.status = 2;
            approval.approver = approver;
        }
    }

    transcriptApprovalType(type:number){
      switch(type){
        case 1:
          return "Contrato"
        case 2:
          return "Capacidade"
      }
    }

    transcriptApprovalExpense(projects){
      let projectTypes = projects.map(project => {
          return project.projectDetails &&
              project.projectDetails.length > 0 &&
              project.projectDetails[0].projectExpense ? "Despesa" : "Custo";
      });

      if(projectTypes.every(type => type == 'Despesa')) return 'Despesa';
      else if(projectTypes.every(type => type == 'Custo')) return 'Custo';
      else return 'Custo/Despesa';
  }

    async getS3Links() {
        this.approvals = this.approvals.map((approval: Approval) => {
            if(approval.approvalInvoice && (approval.approvalInvoice.status == 1 ||
                approval.approvalInvoice.status == 2))
                approval.existsInvoice = true;
            return approval;
        });
    };

    async downloadApprovalInvoice(approval) {
        let invoiceFile = await this.awsService.getFiles(`approvals-invoices/${approval._id}`);
        if (invoiceFile.length == 0){
           this.toastr.warning('Nota fiscal não encontrada');
        }else{
            let a = document.createElement('a');
            document.body.appendChild(a);
            const link = (await this.awsService.download(invoiceFile[0].Key)).split('?')[0];
            a.href = link;
            a.click();
            a.remove();
        }
    }

    verifyApprovalDate(approval) {
      // Alterar a data da variável "limitDate", para o dia "2022-01-03" quando for para Produção.
      let limitDate = new Date("2021-12-01").getTime()
      let approvalDate = new Date(approval.created).getTime()
      if(approvalDate > limitDate){
        return false
      }
      return true
    }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/approvals.component.ts